module.exports = {
    get: function (key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch (e) {
            return localStorage.getItem(key);
        }
    },
    set: function (key, item) {
        try {
            localStorage.setItem(key, JSON.stringify(item));
        } catch (e) {
            localStorage.setItem(key, item);
        }
    },
    remove: function (key) {
        localStorage.removeItem(key);
    }
}


// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/helpers/storage.js